import type {
  TenderExportStatus,
  TenderOutputKind,
  TenderReviewStatus,
  TenderStatus,
  TenderStorageProvider
} from '@cdf/api-client-react';

export const DEFAULT_TENDER_OUTPUTS: TenderOutputKind[] = ['standalone_response', 'completed_buyer_template'];

export const tenderStatusLabels: Record<TenderStatus, string> = {
  draft: 'Draft',
  in_preparation: 'In preparation',
  in_review: 'In review',
  changes_requested: 'Changes requested',
  approved: 'Approved',
  submitted: 'Submitted',
  closed: 'Closed',
  archived: 'Archived'
};

export const storageProviderLabels: Record<TenderStorageProvider, string> = {
  application: 'Application storage',
  sharepoint: 'SharePoint',
  sharepoint_embedded: 'SharePoint Embedded'
};

export const outputKindLabels: Record<TenderOutputKind, string> = {
  standalone_response: 'Standalone Word response',
  completed_buyer_template: 'Completed original buyer template',
  converted_template: 'Converted editable template',
  compliance_matrix: 'Word compliance matrix'
};

type BadgeVariant = 'default' | 'secondary' | 'destructive' | 'outline';

export function tenderStatusVariant(status: TenderStatus): BadgeVariant {
  if (status === 'approved' || status === 'submitted') return 'default';
  if (status === 'changes_requested') return 'destructive';
  if (status === 'closed' || status === 'archived') return 'secondary';
  return 'outline';
}

export function reviewStatusVariant(status: TenderReviewStatus): BadgeVariant {
  if (status === 'approved') return 'default';
  if (status === 'changes_requested' || status === 'invalidated') return 'destructive';
  return 'outline';
}

export function exportStatusVariant(status: TenderExportStatus): BadgeVariant {
  if (status === 'saved') return 'default';
  if (status === 'failed') return 'destructive';
  return 'outline';
}

export function tenderErrorMessage(error: unknown, fallback = 'The tender action could not be completed.') {
  return error instanceof Error && error.message ? error.message : fallback;
}

export function sectionText(content: Record<string, unknown>) {
  if (typeof content.text === 'string') return content.text;
  if (typeof content.markdown === 'string') return content.markdown;
  return '';
}

export function formatTenderDate(value: string | null | undefined) {
  return value ? new Date(value).toLocaleDateString() : '—';
}

export function humanize(value: string) {
  return value.replaceAll('_', ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
}
